/* @ngInject */

export default () => {
  return function (input, type, order) {
    let out = [];
    if (!type) {
      out = input;
    } else {
      out = _.chain(input).sortNatural(type).value();
    }
    if (order) {
      out.reverse();
    }
    return out;
  };
};
